import { createElement, lazy } from 'react'

import { routes } from '../routes'
import { registerRoute } from '../utils/routeRegistry'

const BusinessUnitSelector = lazy(() => import('./businessUnitSelector'))

const initRoute = () => {
    registerRoute({ path: routes.BUSINESS_UNIT_SELECTOR, element: createElement(BusinessUnitSelector) })
}

export default initRoute
